import { render, staticRenderFns } from "./NaviGation_MultiAngle.vue?vue&type=template&id=3ccf6f1f&scoped=true"
import script from "./NaviGation_MultiAngle.vue?vue&type=script&lang=js"
export * from "./NaviGation_MultiAngle.vue?vue&type=script&lang=js"
import style0 from "./NaviGation_MultiAngle.vue?vue&type=style&index=0&id=3ccf6f1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf6f1f",
  null
  
)

export default component.exports